
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { TemplateItemProps } from ".";
import { loading, create } from "store/template";
import { AppMessage } from "components";

interface ApiTemplateCreateInputProps extends Omit<TemplateItemProps, "id"> {
}

type ApiTemplateCreateOutputProps = OutputBaseProps<{ item: TemplateItemProps; }, ApiTemplateCreateInputProps>

export const apiTemplateCreate = async (data: ApiTemplateCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiTemplateCreateOutputProps>("/api/template/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};